import { notifyIssue } from "./notifyIssue";

const seenErrors = new Set();

export function uiErrorReport() {
  window.onerror = function _(message, source, lineno, colno, error) {
    if (seenErrors.has(message)) {
      return;
    }

    seenErrors.add(message);

    const errorDetails = {
      message,
      source,
      lineno,
      colno,
      error,
    };

    // eslint-disable-next-line no-console
    console.error("Global Error Caught:", errorDetails);

    notifyIssue(errorDetails);
  };
}
